import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { IconButton, DialogContent, DialogActions } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import AddWorkoutCalender from "../AddWorkoutCalender";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import { useEffect } from "react";

export default function EditWorkoutPopup({
  open,
  setOpen,
  date,
  programme,
  data,
  reloadList,
  day,
  setEvents,
  events,
  type,
}) {
  const [openCloseDialog, setOpenCloseDialog] = useState(false);
  const childRef = React.useRef();
  const [modalChangeExe, setModalChangeExe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [questionsToSend, setQuestionsToSend] = useState([]);
  const [editShow, setEditShow] = useState([]);

  const handleParentButtonClick = () => {
    childRef.current.childButtonClickUpdate();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgreeDelete = (value) => {
    setOpenCloseDialog(true);
  };

  const handleDelete = async () => {
    handleClose();
    setOpenCloseDialog(false);
  };

  useEffect(() => {
    if (open) {
      setModalChangeExe(false);
      setIsLoading(false);
      const newQuestions = data?.questions || [];
      if (newQuestions && newQuestions.length > 0) {
        setQuestionsToSend(newQuestions);
        setEditShow(newQuestions.map(() => ({ display: false })));
      }
    }
  }, [open]);

  return (
    <div>
      <CustomConfirmation
        openDelete={openCloseDialog}
        setOpenDelete={setOpenCloseDialog}
        title={"Are you sure you want to Close ?"}
        handleAgree={handleDelete}
      />
      <Dialog
        disableEnforceFocus={true}
        open={open}
        fullWidth
        fullScreen={true}
        maxWidth={"lg"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="show-dialog-on-full"
      >
        <div className="text-end mt-2 me-2">
          {modalChangeExe ? (
            <IconButton
              className="back-screen-button"
              onClick={handleAgreeDelete}
            >
              <CloseIcon />
            </IconButton>
          ) : (
            <IconButton className="back-screen-button" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
        <DialogContent
          sx={{
            paddingY: 0,
            height: "80vh",
            overflowY: "auto",
          }}
        >
          <AddWorkoutCalender
            setIsLoading={setIsLoading}
            ref={childRef}
            date={date}
            programme={programme}
            setOpen={setOpen}
            editData={data}
            day={day}
            events={events}
            setEvents={setEvents}
            reloadList={reloadList}
            setModalChangeExe={setModalChangeExe}
            type={type}
            questionsToSend={questionsToSend}
            setQuestionsToSend={setQuestionsToSend}
            editShow={editShow}
            setEditShow={setEditShow}
          />
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            borderTop: "1px solid rgba(0,0,0,0.12)",
            boxShadow: "0px -1px 4px rgba(0,0,0,0.06)",
            position: "sticky",
            bottom: 0,
            backgroundColor: "background.paper",
            zIndex: 10,
          }}
        >
          {data?.workout_loggers?.length > 0 ? (
            <Button
              disabled={isLoading}
              sx={{ textTransform: "inherit" }}
              onClick={isLoading ? "" : handleClose}
              size="small"
              color="primary"
              variant="contained"
              className="small-contained-dialog-button"
            >
              Close
            </Button>
          ) : (
            <>
              {data?.practice_type !== "workbook" ||
              questionsToSend.length > 0 ? (
                <Button
                  disabled={isLoading}
                  sx={{ textTransform: "inherit" }}
                  onClick={isLoading ? "" : handleParentButtonClick}
                  size="small"
                  color="primary"
                  variant="contained"
                  className="small-contained-dialog-button"
                >
                  Save
                </Button>
              ) : (
                ""
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
